<mon-page-header 
    header="{{'Utilization reports' | translate}}"
    subHeader="{{'Download reports in CSV format detailing product and feature utilization for every customer.' | translate}}"
    [monIconDirect]="'faDownload'">
</mon-page-header>

<button class="btn btn-secondary" (click)="downloadLatest()">Download customer-level insights</button>
<div style="margin-top: 30px;">
    <button class="btn btn-secondary" (click)="downloadDomainsDigest()">Download domain-level insights</button>
</div>